import React from "react";

const ProfileIcon = (props) => {
	const { color, ...rest } = props;
	const BUTTON_COLOR = getComputedStyle(document.documentElement)
		.getPropertyValue("--button-color")
		.trim();
	return window.HAS_STRIPED_ICON ? (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="17"
			height="22"
			viewBox="0 0 17 22"
			fill="none">
			<path
				d="M8.35547 13.126C10.5468 13.126 12.5075 13.3061 13.9043 13.8008C14.5992 14.0469 15.1197 14.359 15.4629 14.7334C15.7958 15.0967 15.9814 15.5395 15.9814 16.1055C15.9814 16.416 15.8184 16.8507 15.4307 17.3574C15.0506 17.854 14.4889 18.3743 13.7832 18.8477C12.3704 19.7952 10.4344 20.5194 8.35547 20.5195C6.2642 20.5195 4.32803 19.7946 2.91895 18.8447C2.2149 18.3701 1.65555 17.8482 1.27734 17.3486C0.892012 16.8396 0.728546 16.4 0.728516 16.0811C0.728516 15.5159 0.915205 15.0758 1.24902 14.7148C1.59357 14.3424 2.11644 14.0325 2.81348 13.7891C4.21405 13.3 6.17547 13.126 8.35547 13.126ZM8.35547 0.695312C11.009 0.695563 13.2324 3.31161 13.2324 6.07812C13.2323 8.78518 11.0648 10.9539 8.35547 10.9541C5.6469 10.9541 3.47761 8.78524 3.47754 6.07812C3.47754 3.31154 5.70275 0.695312 8.35547 0.695312Z"
				stroke={color || BUTTON_COLOR}
			/>
		</svg>
	) : (
		<svg
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}>
			<path
				d="M12.5 13.9872C16.8386 13.9872 20.5 14.6922 20.5 17.4122C20.5 19.25 16.8146 22.25 12.5 22.25C8.16237 22.25 4.5 19.25 4.5 17.3882C4.5 14.6672 8.18538 13.9872 12.5 13.9872ZM12.5 1.75C15.4391 1.75 17.794 4.60402 17.794 7.54105C17.794 10.4781 15.4391 12.8331 12.5 12.8331C9.5619 12.8331 7.20601 10.4781 7.20601 7.54105C7.20601 4.60402 9.5619 1.75 12.5 1.75Z"
				fill={color || BUTTON_COLOR}
			/>
		</svg>
	);
};

export default ProfileIcon;
